var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchoolIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "43px",
    viewBox: "0 0 45 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4C517C64-6F33-44E1-A0F9-C8B819ADF1A4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Administrador-Pearson",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u27054.1-Desktop-HD/-mapa-abierto--Copy-46",
    transform: "translate(-344.000000, -278.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(346.000000, 277.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-school",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.55,37 C16.799,38.97 18.462,40.5 20.5,40.5 C22.538,40.5 24.201,38.97 24.45,37 L16.55,37 Z",
    id: "Path",
    fill: "#007FA3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,13 L24.5,13 C22.291,13 20.5,14.791 20.5,17 L20.5,37 L35,37 C36.105,37 37,36.105 37,35 L37,15 C37,13.895 36.105,13 35,13 Z",
    id: "Path",
    stroke: "#007FA3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,15 L4,35 C4,36.105 4.895,37 6,37 L20.5,37 L20.5,18 C20.5,15.25 18.25,13 15.5,13 L6,13 C4.895,13 4,13.895 4,15 Z",
    id: "Path",
    stroke: "#007FA3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#007FA3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "0 8 20.5 0 41 8"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolIcon);
export default __webpack_public_path__ + "static/media/schoolIcon.54f27cc92e4d7aa94932970435169661.svg";
export { ForwardRef as ReactComponent };